import * as CONST from "./actionTypes";

export const loginUser = (payload, callBack, setLoading) => {
  return {
    type: CONST.LOGIN_USER,
    payload: { ...payload },
    callBack,
    setLoading,
  };
};

export const loginUser_Success = (payload) => ({
  type: CONST.LOGIN_USER_SUCCESS,
  payload,
});

export const loginUser_Fail = (payload) => ({
  type: CONST.LOGIN_USER_FAIL,
  payload,
});

// VERIFY OTP

export const verifyOtp = (payload, callBack, setLoading) => {
  return {
    type: CONST.VERIFY_OTP,
    payload: { ...payload },
    callBack,
    setLoading,
  };
};

export const verifyOtp_Success = (payload) => ({
  type: CONST.VERIFY_OTP_SUCCESS,
  payload,
});

export const verifyOtp_Fail = (payload) => ({
  type: CONST.VERIFY_OTP_FAIL,
  payload,
});

// CREATE PASS SUBADMIN

export const createPassSubadmin = (payload, callBack) => {
  return {
    type: CONST.CREATE_PASS_SUBADMIN,
    payload: { ...payload },
    callBack,
  };
};

export const createPassSubadmin_Success = (payload) => ({
  type: CONST.CREATE_PASS_SUBADMIN_SUCCESS,
  payload,
});

export const createPassSubadmin_Fail = (payload) => ({
  type: CONST.CREATE_PASS_SUBADMIN_FAIL,
  payload,
});

// SELECT OTP OPTION

export const selectOtpOption = (payload, callBack, setLoading) => {
  return {
    type: CONST.SELECT_OTP_OPTION,
    payload: { ...payload },
    callBack,
    setLoading,
  };
};

export const selectOtpOption_Success = (payload) => ({
  type: CONST.SELECT_OTP_OPTION_SUCCESS,
  payload,
});

export const selectOtpOption_Fail = (payload) => ({
  type: CONST.SELECT_OTP_OPTION_FAIL,
  payload,
});
